module.exports = __webpack_public_path__ + "img/Curriculum.18928eb3.png";